function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M167.842 137.972L221.31 92.7188C223.706 90.6864 227.371 91.4143 228.808 94.208L260.925 156.459C261.964 158.482 261.474 160.952 259.74 162.424L206.272 207.677C203.876 209.709 200.212 208.981 198.774 206.188L166.658 143.937C165.618 141.914 166.108 139.444 167.842 137.972Z",
  fill: "#111927"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M253.038 157.987L223.578 100.893L174.536 142.395L203.993 199.5L253.038 157.987Z",
  stroke: "#F2F2EF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M223.578 100.893L203.993 199.5",
  stroke: "#F2F2EF",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M210.674 165.864L174.535 142.395L216.897 134.529L253.038 157.987L210.674 165.864Z",
  stroke: "#F2F2EF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M113.18 190.838C86.5017 193.859 62.9282 189.803 45.006 179.112C24.826 167.081 12.635 147.011 9.69927 121.088C6.76353 95.164 14.1578 72.8768 31.1362 56.6372C46.1673 42.2485 68.1381 33.052 94.7101 29.9919C94.8945 29.971 95.0919 29.9147 95.2931 29.8919C95.7459 29.8406 96.4128 29.7312 97.2848 29.6324C103.824 28.8918 126.94 27.1062 149.447 35.2399C177.94 45.5488 194.901 67.8462 198.493 99.7077C201.428 125.631 194.034 147.919 177.056 164.158C161.978 178.586 139.908 187.811 113.23 190.832L113.197 190.836L113.18 190.838Z",
  fill: "#00C16B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M111.606 176.495L111.573 176.499C110.181 176.657 108.96 175.623 108.855 174.242L107.186 152.455C107.113 151.512 107.801 150.687 108.723 150.583L108.807 150.573C109.746 150.467 110.601 151.117 110.738 152.036L114.267 174.343C114.429 175.326 113.734 176.237 112.747 176.366C112.361 176.41 111.975 176.454 111.59 176.497L111.606 176.495ZM78.628 171.874C78.0218 171.62 77.4156 171.366 76.8075 171.095C75.8953 170.689 75.5017 169.613 75.9453 168.73L85.7682 148.393C86.182 147.548 87.1763 147.181 88.0492 147.54L88.0828 147.536C88.9427 147.932 89.3604 148.92 89.0342 149.789L80.9609 170.88C80.6069 171.803 79.555 172.262 78.6447 171.872L78.628 171.874ZM140.547 163.911L127.821 145.261C127.292 144.489 127.478 143.432 128.229 142.871L128.263 142.867C129.013 142.29 130.079 142.407 130.671 143.138L144.901 160.667C145.531 161.428 145.388 162.565 144.608 163.179C144.093 163.577 143.561 163.977 143.027 164.361C142.227 164.944 141.101 164.748 140.532 163.93L140.547 163.911ZM51.3066 150.92C50.9086 150.405 50.5086 149.872 50.1255 149.338C49.5424 148.538 49.7375 147.412 50.5563 146.844L69.2063 134.117C69.9785 133.588 71.0337 133.758 71.5962 134.526L71.6 134.56C72.1775 135.309 72.0604 136.376 71.3293 136.968L53.8212 151.23C53.0603 151.859 51.9233 151.716 51.3085 150.937L51.3066 150.92ZM162.417 138.524L142.094 128.682C141.249 128.269 140.882 127.274 141.258 126.399L141.255 126.366C141.65 125.506 142.638 125.088 143.507 125.414L164.583 133.506C165.506 133.86 165.965 134.912 165.576 135.823C165.321 136.429 165.067 137.035 164.797 137.643C164.39 138.555 163.314 138.949 162.432 138.505L162.417 138.524ZM38.105 119.077C38.0309 118.423 37.955 117.752 37.8809 117.098C37.7689 116.109 38.518 115.226 39.513 115.164C45.7644 114.728 55.8001 113.965 62.0084 113.449C62.9512 113.376 63.7931 114.062 63.8995 115.001L63.9128 115.118C64.0191 116.057 63.3854 116.91 62.4502 117.05L40.1451 120.595C39.1614 120.757 38.2505 120.062 38.1217 119.075L38.105 119.077ZM144.451 107.356L144.459 107.423C144.406 106.801 144.352 106.179 144.282 105.558C144.175 104.619 144.809 103.766 145.744 103.626L168.048 100.065C169.031 99.9023 169.942 100.597 170.069 101.568C170.101 101.853 170.143 102.222 170.185 102.591C170.354 104.083 169.246 105.398 167.748 105.516L144.448 107.323L144.451 107.356ZM64.6612 95.3329L43.5709 87.2596C42.6476 86.9056 42.1888 85.8537 42.5783 84.9434C42.8323 84.3372 43.0863 83.731 43.359 83.1397C43.7652 82.2275 44.8416 81.8339 45.724 82.2775L66.0595 92.0836C66.9046 92.4974 67.2719 93.4918 66.9123 94.3647L66.9161 94.3982C66.5209 95.2582 65.5322 95.6758 64.6631 95.3497L64.6612 95.3329ZM136.552 86.1896L136.548 86.1561C135.971 85.4063 136.088 84.34 136.819 83.7477L154.327 69.4861C155.088 68.8565 156.225 68.9995 156.84 69.779C157.238 70.2944 157.638 70.8265 158.021 71.3606C158.604 72.1607 158.409 73.2867 157.59 73.8549L138.959 86.5964C138.186 87.1254 137.131 86.9562 136.569 86.1877L136.552 86.1896ZM77.4826 77.628L63.221 60.1199C62.5914 59.359 62.7343 58.2219 63.5139 57.6072C64.0292 57.2091 64.5614 56.8092 65.0954 56.4261C65.8955 55.8429 67.0215 56.0381 67.5898 56.8569L80.3331 75.5049C80.8622 76.2772 80.6929 77.3324 79.9245 77.8949L79.8909 77.8987C79.1411 78.4761 78.0749 78.3591 77.4826 77.628ZM120.099 73.1755L120.065 73.1793C119.205 72.7842 118.771 71.7974 119.114 70.9264L127.17 49.8379C127.524 48.9147 128.576 48.4559 129.487 48.8453C130.093 49.0993 130.699 49.3534 131.307 49.6242C132.219 50.0304 132.613 51.1067 132.169 51.9891L122.363 72.3247C121.949 73.1697 120.955 73.5371 120.082 73.1774L120.099 73.1755ZM99.3285 70.1779C98.3895 70.2843 97.5346 69.6338 97.3967 68.7154L93.8517 46.4102C93.6912 45.4433 94.3676 44.5176 95.3551 44.3888C96.1096 44.3033 96.8623 44.2011 97.6188 44.1324C98.5746 44.0242 99.437 44.7417 99.5453 45.6975L102.003 67.854C102.129 68.9607 101.341 69.95 100.234 70.0754C99.9657 70.1058 99.6807 70.138 99.3621 70.1741L99.3285 70.1779Z",
  fill: "#027A48"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M95.8153 37.2033C47.6738 42.6551 11.2069 69.916 16.943 120.267C22.6119 170.626 64.2514 189.042 112.393 183.59L112.359 183.594C160.501 178.142 196.968 150.881 191.232 100.53C182.431 22.3674 92.8473 37.5394 95.8153 37.2033V37.2033Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M109.416 162.545C96.3029 164.03 83.2329 158.394 75.296 147.846C71.678 143.042 70.9327 136.911 73.299 131.412C75.6394 125.984 80.7302 122.198 86.5655 121.537C87.3872 121.444 88.2164 121.418 89.0346 121.444C94.2679 121.616 99.5432 121.409 104.691 120.826C109.839 120.243 115.01 119.267 120.089 117.927C120.898 117.717 121.712 117.557 122.517 117.465C128.369 116.803 134.16 119.357 137.655 124.124C141.19 128.937 141.836 135.097 139.384 140.589C134.007 152.644 122.512 161.062 109.416 162.545Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M88.7665 129.728C81.8279 129.495 77.7409 137.345 81.9009 142.886C87.8979 150.852 97.8369 155.534 108.485 154.329C119.133 153.123 127.756 146.338 131.837 137.231C134.669 130.899 128.913 124.163 122.202 125.942C111.238 128.848 100.103 130.109 88.7665 129.728Z",
  fill: "#111927",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M107.578 154.415C98.6434 155.155 90.2575 151.74 84.3821 145.748C86.4745 143.83 89.1628 142.523 92.2146 142.177C99.8441 141.313 106.714 146.785 107.576 154.398L107.578 154.415Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M107.578 154.415C98.6434 155.155 90.2575 151.74 84.3821 145.748C86.4745 143.83 89.1628 142.523 92.2146 142.177C99.8441 141.313 106.714 146.785 107.576 154.398L107.578 154.415Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M91.0978 129.77L91.508 133.392C91.7606 135.622 90.1398 137.657 87.9096 137.909L86.4005 138.08C84.1536 138.334 82.1356 136.712 81.8831 134.482L81.7406 133.224C83.214 131.087 85.7136 129.615 88.7664 129.728C89.551 129.758 90.317 129.773 91.0997 129.786L91.0978 129.77Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M100.799 129.504L101.118 132.321C101.371 134.551 99.767 136.584 97.5201 136.838L96.0277 137.007C93.7808 137.262 91.7628 135.639 91.5103 133.409L91.1001 129.787C94.3503 129.843 97.5815 129.732 100.799 129.504Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M110.425 128.414L110.744 131.231C110.996 133.461 109.392 135.494 107.145 135.748L105.636 135.919C103.406 136.172 101.371 134.551 101.119 132.321L100.8 129.504C104.018 129.275 107.237 128.91 110.425 128.414Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M119.956 126.502L120.366 130.124C120.619 132.354 119.015 134.387 116.768 134.641L115.259 134.812C113.029 135.064 110.994 133.444 110.741 131.214L110.422 128.396C113.61 127.9 116.799 127.267 119.956 126.502Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M129.849 127.776L129.991 129.034C130.244 131.264 128.623 133.298 126.393 133.551L124.884 133.722C122.654 133.974 120.619 132.354 120.366 130.124L119.956 126.502C120.716 126.314 121.459 126.128 122.217 125.923C125.169 125.147 127.933 126.006 129.847 127.759L129.849 127.776Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M128.531 120.181C139.671 118.919 147.68 108.865 146.418 97.7244C145.157 86.5836 135.102 78.575 123.962 79.8366C112.821 81.0983 104.812 91.1524 106.074 102.293C107.336 113.434 117.39 121.443 128.531 120.181Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M129.532 99.6369L136.948 101.531C136.711 103.341 135.981 105.14 134.746 106.689C131.044 111.337 124.286 112.102 119.672 108.396C115.026 104.71 114.26 97.9528 117.965 93.3214C121.652 88.692 128.41 87.9267 133.039 91.6143C134.589 92.8484 135.684 94.4227 136.338 96.1489L129.534 99.6537L129.532 99.6369Z",
  fill: "#111927"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M113.983 71.8131C109.993 70.7704 107.437 66.7971 108.23 62.6992C109.052 58.4113 113.183 55.5997 117.471 56.4219L137.727 60.2759C142.013 61.0813 144.827 65.2292 144.004 69.5172C143.182 73.8052 139.051 76.6167 134.763 75.7946L114.507 71.9405C114.334 71.9092 114.159 71.8611 113.985 71.8298L113.983 71.8131Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M85.8297 75.0014C89.4857 73.0928 91.0883 68.6485 89.3993 64.8317C87.6392 60.8362 82.9838 59.0197 78.9883 60.7799L60.1072 69.066C56.1098 70.8095 54.2952 75.4816 56.0554 79.4771C57.8156 83.4726 62.4709 85.2891 66.4664 83.5289L85.3475 75.2428C85.5095 75.1735 85.6696 75.0874 85.8316 75.0181L85.8297 75.0014Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M81.7971 125.473C92.9379 124.212 100.947 114.157 99.6849 103.017C98.4232 91.8759 88.3691 83.8673 77.2283 85.129C66.0875 86.3906 58.0789 96.4448 59.3406 107.586C60.6022 118.726 70.6564 126.735 81.7971 125.473Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M82.7992 104.929L90.2147 106.824C89.9781 108.634 89.2476 110.432 88.0135 111.981C84.311 116.629 77.5534 117.395 72.9389 113.688C68.2927 110.003 67.5274 103.245 71.2317 98.6137C74.9193 93.9843 81.6769 93.219 86.3064 96.9066C87.8557 98.1407 88.9511 99.715 89.6051 101.441L82.8011 104.946L82.7992 104.929Z",
  fill: "#111927"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M207.746 79.6915C205.067 79.2624 202.749 77.6662 201.396 75.3143L181.597 40.8681C178.82 35.9377 177.788 30.1861 178.679 24.6265C180.854 11.0464 193.669 1.76933 207.25 3.94449C211.591 4.63981 215.658 6.47479 219.042 9.21824C223.106 7.66769 227.543 7.19494 231.884 7.89026C245.464 10.0654 254.741 22.8812 252.566 36.4613C251.78 41.3672 249.597 45.8508 246.238 49.4671L246.1 49.6521L215.155 77.5098C213.134 79.3296 210.432 80.1299 207.745 79.6995L207.746 79.6915Z",
  fill: "#FF8FE3"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M247.16 35.5956C246.513 39.6381 244.661 43.1899 242.035 45.9472L242.032 45.9633L211.495 73.4396C209.843 74.9212 207.253 74.5063 206.146 72.5828L186.347 38.1365C184.258 34.4337 183.36 30.0194 184.085 25.4927C185.785 14.8819 195.773 7.65136 206.384 9.3509C211.072 10.1018 215.096 12.4677 217.991 15.7866C221.777 13.5378 226.339 12.5471 231.019 13.2967C241.629 14.9962 248.86 24.9848 247.16 35.5956Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M217.991 15.7865C213.206 18.6367 209.67 23.5076 208.72 29.4383",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMsKiwiEthHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 219,
    viewBox: "0 0 273 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsKiwiEthHeart);
export default __webpack_public_path__ + "static/media/ms-kiwi-eth-heart.15ad5cf4.svg";
export { ForwardRef as ReactComponent };